<template>
  <div class="bg-primary pt-10 md:p-16 gap-4 fixed inset-0 overflow-y-auto overflow-x-hidden">
    <slot name="header"><AltPageHeader /></slot>
    <AltPageContent>
      <slot></slot>
    </AltPageContent>
    <slot name="footer"><AltPageFooter /></slot>
  </div>
</template>

<script setup>
import AltPageHeader from "./AltPageHeader.vue";
import AltPageContent from "./AltPageContent.vue";
import AltPageFooter from "./AltPageFooter.vue";
</script>
